module.exports = __webpack_public_path__ + "static/media/dsc_0001.e6787b78.jpg";